<mat-expansion-panel class="mb-3 shadow-sm" [expanded]="false">
  <mat-expansion-panel-header [ngClass]="{'horny-dolny-okraj': akcia.poznamka}">

      <div class="container-fluid">
        <div class="row">
          <div class="col-2 p-0">
            <mat-checkbox [(ngModel)]="akcia.prihlaseny" [disabled]="disabled" (click)="checkboxClick($event)"></mat-checkbox>
          </div>
          <div class="col-8 p-0 mt-auto mb-auto">
            <span>{{akcia.termin}}</span> <span class="text-black-50 p-1">{{akcia.miestnost}}</span>
            <div *ngIf="akcia.poznamka" class="text-black-50 text-truncate">
              <span i18n>Poznámka</span>:
              <!-- <span>{{akcia.poznamka}}</span> -->
              <span [matTooltip]="akcia.poznamka">{{akcia.poznamka}}</span>
            </div>
          </div>
          <div class="col-2 p-0 mt-auto mb-auto">{{akcia.pravidelnost}}</div>
        </div>
      </div>

    <mat-panel-description>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div class="small text-black-50 container d-none d-xl-block">
    <hr/>
    <div class="row">
      <div class="col col-xl-3"><span class="fw-bold text-nowrap" i18n>Vyučujúci</span>:</div>
      <div class="col">{{akcia.vyucujuci}}</div>
    </div>
    <div class="row"><div class="col col-xl-3 fw-bold" i18n>Prihlásení:</div> <div class="col">{{akcia.prihlaseni}}</div></div>
    <div class="row"><div class="col col-xl-3 fw-bold" i18n>Max. počet:</div> <div class="col">{{akcia.maxPocet}}</div></div>
    <div *ngIf="akcia.jazykVyucby" class="row"><div class="col-3 fw-bold" i18n>Jazyk výučby:</div> <div class="col">{{akcia.jazykVyucby}}</div></div>
    <div *ngIf="akcia.rozsah" class="row">
      <div class="col col-xl-3">
        <span class="fw-bold" i18n>Rozsah výučby</span>:
      </div>
      <div class="col">{{akcia.rozsah}} ({{akcia.rozsahASposobVyucbyPopis}})</div>
    </div>
    <div class="row">
      <div class="col-3"><span class="fw-bold" i18n>Študijné skupiny</span>:</div>
      <div class="col">{{akcia.studijneSkupiny}}</div>
    </div>
    <div class="row" *ngIf="akcia.poznamka">
      <div class="col-3"><span class="fw-bold" i18n>Poznámka</span>:</div>
      <div class="col">{{akcia.poznamka}}</div>
    </div>
  </div>

  <div class="small text-black-50 d-block d-xl-none">
    <hr/>
    <div><b><span i18n>Vyučujúci</span></b></div>
    <div>{{akcia.vyucujuci}}</div>
    <br/>
    <div><b><span i18n>Prihlásení</span></b></div>
    <div>{{akcia.prihlaseni}}</div>
    <br/>
    <div><b><span i18n>Max. počet</span></b></div>
    <div>{{akcia.maxPocet}}</div>
    <br/>
    <div *ngIf="akcia.jazykVyucby">
      <div><b><span i18n>Jazyk výučby</span></b></div>
      <div>{{akcia.jazykVyucby}}</div>
      <br/>
    </div>
    <div *ngIf="akcia.rozsah">
      <div class="fw-bold"><span i18n>Rozsah výučby</span></div>
      <div>{{akcia.rozsah}} ({{akcia.rozsahASposobVyucbyPopis}})</div>
      <br/>
    </div>
    <div><b><span i18n>Študijné skupiny</span></b></div>
    <div>{{akcia.studijneSkupiny}}</div>
    <div *ngIf="akcia.poznamka"><b><span i18n>Poznámka</span></b></div>
    <div *ngIf="akcia.poznamka">{{akcia.poznamka}}</div>
  </div>

</mat-expansion-panel>
